import { render, staticRenderFns } from "./CustomerNaturalForm.vue?vue&type=template&id=33ed5801"
import script from "./CustomerNaturalForm.vue?vue&type=script&lang=js"
export * from "./CustomerNaturalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports